export const ENTITY_TYPE = {
  LINK: 'LINK',
  IMAGE: 'IMAGE',
  BUTTON: 'BUTTON',
  MERGE_TAG: 'MERGE_TAG',
}
type MergeTagType =
  | 'first-name-merge-tag'
  | 'last-name-merge-tag'
  | 'full-name-merge-tag'
export const MERGE_TAG_TEMPLATE_VAR: Record<MergeTagType, string> = {
  'first-name-merge-tag': 'first_name',
  'last-name-merge-tag': 'last_name',
  'full-name-merge-tag': 'full_name',
}
export const MERGE_TAG_UI_TEXT: Record<MergeTagType, string> = {
  'first-name-merge-tag': '<...> First name',
  'last-name-merge-tag': '<...> Last name',
  'full-name-merge-tag': '<...> Full name',
}
export const MERGE_TAG_TRANSLATION: Record<MergeTagType, string> = {
  'first-name-merge-tag': 'First name',
  'last-name-merge-tag': 'Last name',
  'full-name-merge-tag': 'Full name',
}
export const lineHeightOptions = [
  {
    value: '1',
    label: 'Single spacing',
  },
  {
    value: '1.25',
    label: '1 1/4 spacing',
  },
  {
    value: '1.5',
    label: '1 1/2 spacing',
  },
  {
    value: '2',
    label: 'Double spacing',
  },
]
export const DEFAULT_LINE_HEIGHT = 1.5
export const FONT_FAMILY_OPTIONS = [
  {
    label: 'Arial',
    value: 'Arial, sans-serif',
  },
  {
    label: 'Comic Sans',
    value: 'Comic Sans MS, cursive, sans-serif',
  },
  {
    label: 'Courier New',
    value: 'Courier New, monospace',
  },
  {
    label: 'Georgia',
    value: 'Georgia, serif',
  },
  {
    label: 'Helvetica',
    value: 'Helvetica, sans-serif',
  },
  {
    label: 'Lucida',
    value: 'Lucida Sans Unicode, Lucida Grande, sans-serif',
  },
  {
    label: 'Tahoma',
    value: 'Tahoma, sans-serif',
  },
  {
    label: 'Times New Roman',
    value: 'Times New Roman, serif',
  },
  {
    label: 'Trebuchet',
    value: 'Trebuchet MS, sans-serif',
  },
  {
    label: 'Verdana',
    value: 'Verdana, sans-serif',
  },
  {
    label: 'Roboto',
    value: 'Roboto, sans-serif',
  },
]
export const DEFAULT_FONT_FAMILY = 'Helvetica, Arial, sans-serif'
